import { isEqual, isUndefined, omitBy } from 'lodash';

export function createFilterEventProperties(newFilters, prevFilters, mappingFunction) {
  return omitBy(mappingFunction(omitBy(newFilters, (value, key) => isEqual(value, prevFilters[key]))), isUndefined);
}
